module.exports = __webpack_public_path__ + "static/media/tools.924b9905.png";